/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from "react";

import type { UserTypeEnum } from "~/gql/graphql";

import type { SearchableFieldType } from "../claims/searchable/types";
import type { UserPermissionConfig } from "../types";

interface ClaimList {
  allowColumnFilters: boolean;
  columns: Map<
    string,
    | {
        default: boolean;
        disabled: boolean;
      }
    | {
        default: boolean;
        disabled?: undefined;
      }
  >;
  dataFragment: any;
  query: any;
}

interface AuditProgress {
  showAsStats: {
    row1: string[];
    row2: string[];
  };
  progressBarsStateTypesToShow: string[];
}

export interface UserContextValue {
  auditProgress: AuditProgress;
  claimIntakeEnabled: boolean;
  claimList: ClaimList;
  dashboard: any;
  email: string;
  firstName: string;
  id: string;
  internalOnly: boolean;
  insurers: any;
  lastName: string;
  permissions: UserPermissionConfig;
  search: {
    fields: Set<SearchableFieldType | "*">;
    canSearchClaims: boolean;
    isValidInformationForFormFilter: {
      batchClaim: Record<string, unknown>;
    };
  };
  title: string;
  userType: UserTypeEnum;
  providers: any;
  readOnly: boolean;
  reports: any;
  workstation: any;
}

export const UserContext = createContext<UserContextValue | null>(null);

export const useUserContext = (): UserContextValue => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("useUserContext must be used within a UserContext");
  }
  return context;
};
